export default "__VITE_ASSET__Dq188TTU__"